<div class="product-view-container">
  <nav class="product-header sticky-top navbar navbar-light bg-light" [ngClass]="{ 'im-dirty': isModified }">
    <span class="navbar-brand">Add Product</span>
    <div class="navbar-nav mr-auto"></div>
    <button type="button" class="btn btn-secondary btn-cancel mr-3" [routerLink]="['/products']">
      <span>Cancel</span>
    </button>
    <button type="button" class="btn btn-primary btn-save" (click)="save()">
      <span>Save</span>
    </button>
    <button mat-icon-button class="btn-close" (click)="back()">
      <mat-icon>close</mat-icon>
    </button>
  </nav>
  <div class="product-container">
    <mat-card>
      <div class="row">
        <div class="col-8">
          <label>Title</label>
          <div class="input-group mb-3">
            <input [(ngModel)]="product.Name" type="text" class="form-control" (input)="dataChanged()">
          </div>
          <label>Product Code</label>
          <div class="input-group mb-3">
            <input [(ngModel)]="product.Code" type="text" class="form-control" (input)="dataChanged()">
          </div>
          <label>Product SKU</label>
          <div class="input-group mb-3">
            <input [(ngModel)]="product.SKU" type="text" class="form-control" (input)="dataChanged()">
          </div>
          <label>Description</label>
          <div class="input-group mb-3">
            <textarea [(ngModel)]="product.Description" class="form-control" rows="5" (input)="dataChanged()"></textarea>
          </div>
          <label>Weight</label>
          <div class="input-group mb-3">
            <input [(ngModel)]="product.Weight" type="text" class="form-control" aria-label="Weight">
          </div>
          <label>Categories</label>
          <mat-chip-list aria-label="Product Categories">
            <mat-chip>Accessories</mat-chip>
            <mat-chip>Food</mat-chip>
          </mat-chip-list>
        </div>
      </div>
    </mat-card>
  </div>
</div>